export const isProd = process.env.NODE_ENV === 'production' && process.env.REACT_APP_PROJECT_ID === 'sacri-6bae3'
export const { API_ENDPOINT, STRIPE_PUBLIC_KEY, CLOUDINARY_BUCKET_PATH, OLD_ADMIN_URL, GRAPHQL_ENDPOINT } = (() => {
  if (isProd) {
    return {
      API_ENDPOINT: 'https://asia-northeast1-sacri-6bae3.cloudfunctions.net',
      STRIPE_PUBLIC_KEY: 'pk_live_bXE7eAQFGFYnzJWg8iTDrwGb00ZamWD72Q',
      CLOUDINARY_BUCKET_PATH: 'https://res.cloudinary.com/sacri/image/upload/prod',
      OLD_ADMIN_URL: 'https://sacri-owners.web.app/',
      GRAPHQL_ENDPOINT: 'https://sacri-api-pexmgfania-an.a.run.app/graphql',
    }
  } else {
    return {
      API_ENDPOINT: 'https://asia-northeast1-yktt-b7f92.cloudfunctions.net',
      STRIPE_PUBLIC_KEY: 'pk_test_1jzDEjKdh7nGxRYba6xsRfy600Hi4teGle',
      CLOUDINARY_BUCKET_PATH: 'https://res.cloudinary.com/sacri/image/upload/dev',
      OLD_ADMIN_URL: 'https://dev-sacri-owners.web.app/',
      GRAPHQL_ENDPOINT: 'https://sacri-api-giwzagtw7q-an.a.run.app/graphql',
    }
  }
})()
